import React from 'react';

import {Container} from 'Components/Utilities';
import PushNotifications from 'Components/Partials/PushNotifications';

import Header from './Header';
import Footer from './Footer';

export default class Authenticated extends React.Component {
    /**
     * @method render
     * @returns {JSX.Element}
     */
    render () {
        const {children, pageTitle} = this.props;

        return (
            <React.Fragment>
                <Header pageTitle={pageTitle} />

                {window.base.features.allow_push_notifications && <PushNotifications />}

                <Container>
                    {children}
                </Container>

                <Footer />
            </React.Fragment>
        )
    };
}
